import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { z } from "zod";
import { DispositivoMeseraRespuestaSchema, type DispositivoMeseraRespuesta } from "@tentacion/shared";
import { apiFetch } from "../api";
import { useAuth } from "../auth";

export function useDispositivosMesera(habilitado = true) {
  const { usuarioId } = useAuth();
  return useQuery({
    queryKey: ["dispositivos-mesera"],
    queryFn: () =>
      apiFetch<DispositivoMeseraRespuesta[]>("/dispositivos-mesera", {
        schema: z.array(DispositivoMeseraRespuestaSchema),
      }),
    enabled: Boolean(usuarioId) && habilitado,
    refetchInterval: 10000,
  });
}

function useAccionDispositivo(accion: "aprobar" | "rechazar" | "revocar") {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (dispositivoId: string) =>
      apiFetch<DispositivoMeseraRespuesta>(`/dispositivos-mesera/${dispositivoId}/${accion}`, {
        method: "POST",
        schema: DispositivoMeseraRespuestaSchema,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["dispositivos-mesera"] });
    },
  });
}

export function useAprobarDispositivo() {
  return useAccionDispositivo("aprobar");
}

export function useRechazarDispositivo() {
  return useAccionDispositivo("rechazar");
}

export function useRevocarDispositivo() {
  return useAccionDispositivo("revocar");
}
